import { Checkbox, FormControl, FormControlLabel, InputLabel, MenuItem, Paper, Select, SelectChangeEvent, Stack } from "@mui/material";
import { Dayjs } from "dayjs";
import { RouteType, RouteTypes, useRouteSettings, useRouteSettingsActions } from "../../stores/RouteSettingsStore";
import { DateTimeInput } from "../common/DateTimeInput";
import { NumberInput } from "../common/NumberInput";
import { StringInput } from "../common/StringInput";
import BruksklasseModulvogntogSettings from "./BruksklasseModulvogntogSettings";
import BruksklasseNormalTransportSettings from "./BruksklasseNormalTransportSettings";
import BruksklasseSpesialTransportSettings from "./BruksklasseSpesialTransportSettings";
import BruksklasseTommerTransportSettings from "./BruksklasseTommerTransportSettings";
import { EnvironmentSelector } from "./EnvironmentSelector";
import ExternalRouteInput from "./ExternalRouteInput";
import { UpdateRouteButton } from "../Map/UpdateRouteButton";
import DropdownInput from "../common/DropdownInput";
import { useMap } from "react-leaflet";

export function RouteTypeInput() {
    const routeSettings = useRouteSettings();
    const { setRouteSettings } = useRouteSettingsActions();

    const onChange = (event: SelectChangeEvent<RouteType>) => {

        setRouteSettings({...routeSettings, routeType: event.target.value as RouteType});
    }

    return (
        <FormControl style={{}}>
            <InputLabel id="routetype-label">RouteType</InputLabel>
            <Select
                MenuProps={{disablePortal: true}}
                labelId="routetype-label"   
                value={routeSettings.routeType}
                variant="standard"                        
                onChange={onChange}>                   
                {RouteTypes.map( routeType => {
                    return (
                        <MenuItem key={routeType} value={routeType}>{routeType}</MenuItem>                        
                    )
                })} 
                    
            </Select>
        </FormControl>
    )
}

function IncludeObstructedRouteSettings() {

    const routeSettings = useRouteSettings();
    const { setRouteSettings }  = useRouteSettingsActions();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setRouteSettings({...routeSettings, includeObstructedRoutes: event.target.checked});
    };
  
    return (
        <FormControl>
            <FormControlLabel control={<Checkbox
                checked={routeSettings.includeObstructedRoutes}
                onChange={handleChange}
                inputProps={{ 'aria-label': 'IncludeObstructedRoutes' }}
            />}
            label="IncludeObstructedRoutes"/>
            
        </FormControl>
      
    );
}

function RouteSettingsComponent() {

    const routeSettings = useRouteSettings();
    const { setRouteSettings }  = useRouteSettingsActions();
    
    return (
        <Stack spacing={3} style={{paddingTop:"10px"}}>
            <RouteTypeInput />            
            <DateTimeInput 
                label="StartTime"
                onChange={(value:Dayjs) => {setRouteSettings({...routeSettings, startTime: value})}}
                value={routeSettings.startTime}/>
            <NumberInput
                label="Vekt (T)" 
                onChange={(value:number | null) => {setRouteSettings({...routeSettings, weight: value})}} 
                value={routeSettings.weight}/>

            <NumberInput
                label="Høyde (m)"
                onChange={(value:number | null) => {setRouteSettings({...routeSettings, height: value})}}
                value={routeSettings.height}/>

            <NumberInput
                label="Lengde (m)"
                onChange={(value:number | null) => {setRouteSettings({...routeSettings, length: value})}}
                value={routeSettings.length}/>            

            <StringInput 
                label="AvoidSituationIds"
                onChange={(value:string) => {setRouteSettings({...routeSettings, avoidSituationIds: value})}}
                value={routeSettings.avoidSituationIds}
            />
            <StringInput 
                label="AvoidFeatureInstanceIds"
                onChange={(value:string) => {setRouteSettings({...routeSettings, avoidFeatureInstanceIds: value})}}
                value={routeSettings.avoidFeatureInstanceIds}
            />
            <StringInput 
                label="AvoidTrafficMessageTypes"
                onChange={(value:string) => {setRouteSettings({...routeSettings, avoidTrafficMessageTypes: value})}}
                value={routeSettings.avoidTrafficMessageTypes}
            />
            <DropdownInput />
            <IncludeObstructedRouteSettings/>
            <BruksklasseNormalTransportSettings />
            <BruksklasseSpesialTransportSettings />
            <BruksklasseTommerTransportSettings />
            <BruksklasseModulvogntogSettings />
            <ExternalRouteInput/>
            <EnvironmentSelector/>            
            <UpdateRouteButton/>
        </Stack>
    )
}

export default function RoutingParameters() {
    const map = useMap();

    const mouseOver = () => {
        map.scrollWheelZoom.disable();
        map.doubleClickZoom.disable();
    };

    const mouseExit = ()  => {
        map.scrollWheelZoom.enable();
        map.doubleClickZoom.enable();
    }

    return (
        <Paper onMouseOver={mouseOver} onMouseLeave={mouseExit}>
           <RouteSettingsComponent/>
        </Paper>
    )
}